module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_02-16e316588c24cd898f9d1c7139552450.png";